<template>
  <div class="container">
    <div id="app">
      <HeaderBar v-if="header" />

      <section class="radio-buttons">
        <!--<div class="line" :checked="section === 'about'" @click="handleTabChange('about')">
          <RadioButton :checked="section === 'about'" />
          Про сайт
        </div>-->
        <div class="line" :checked="section === 'zoz'" @click="handleTabChange('zoz')">
          <RadioButton :checked="section === 'zoz'" />
          ЗОЗ, які надають послуги із ЗПТ
        </div>
        <div class="line" :checked="section === 'harm_reduction'" @click="handleTabChange('harm_reduction')">
          <RadioButton :checked="section === 'harm_reduction'" />
          Послуги зменшення шкоди
        </div>
      </section>

      <!-- Connecting a modal window component -->
      <ModalWindow
        :show="showModal"
        :preselectedGroup="selectedGroup"
        :preselectedServices="selectedServices"
        @confirm="handleModalConfirm"
        @groupSelected="handleGroupSelected"
      />

      <!-- Modal window for displaying the details of the institution -->
      <PlaceDetailsModal
        :show="showPlaceDetailsModal"
        :place="selectedPointDetails"
        @close="closePlaceDetailsModal"
      />

      <section :class="['content', 'main-grid', { 'single-column': section === 'about' }]">
        <!--<AboutPage v-if="section === 'about'" />-->

        <main-map
          ref="main_map"
          :localPoints="[...localFilteredPoints]"
          @point_selected="p => select_point(p, true)"
          v-if="section !== 'about' && data && localFilteredPoints.length > 0"
          :show_legend="section === 'socDISABLED'"
        />

        <div class="right-column" v-if="section !== 'about' && points">
          <!-- SiteBreadcrumbs відображається лише для ПЗШ -->
          <SiteBreadcrumbs
            v-if="section === 'harm_reduction'"
            :group="selectedGroup"
            :services="selectedServices"
          />

          <!-- Кнопка "Змінити групу/послуги" -->
          <button
            v-if="section === 'harm_reduction'"
            @click="onChangeGroupServices"
            class="change-selection-button"
          >
            Змінити групу/послуги
          </button>


          <!-- Пошук відображається лише для ЗОЗ -->
          <SearchField
            v-if="section === 'zoz'"
            :search_index="[]"
            placeholder="Введіть ваш пошуковий запит"
            @changed="val => this.term = val"
          />

          <SearchResults
            :points="filtered_points"
            :section="section"
            @point_selected="select_point"
            ref="search_results"
          />
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import MainMap from '@/components/MainMap.vue';
import RadioButton from '@/components/RadioButton.vue';
import SearchResults from '@/components/SearchResults.vue';
import { address, search_field } from '@/utils';
import SearchField from '@/components/SearchField.vue';
//import AboutPage from '@/components/AboutPage.vue';
import ModalWindow from '@/components/ModalWindow.vue';
import PlaceDetailsModal from '@/components/PlaceDetailsModal.vue';
import SiteBreadcrumbs from '@/components/SiteBreadcrumbs.vue';
import HeaderBar from "@/components/HeaderBar.vue";

const API_ROOT = process.env.VUE_APP_API_ROOT;

// Групи вразливості для відображення (мають бути визначені на початку, у спільному scope)
const vulnerabilityGroupLabels = {
  PWID: "ЛВНІ",
  SW: "СП",
  MSM: "ЧСЧ",
};

const serviceMapping = {
  tb_screening: 'services_test_TB',
  ptv: 'services_test_HIV',
  syringe_exchange: 'exchange_distribution_of_syringes',
  condom_distribution: 'dispensing_contraceptives',
  information_services: 'consultation',
};

// Detect HIV testing both by UI key ('ptv') and backend key ('services_test_HIV')
function isHivServiceKey(k) {
  const v = (k || '').toString().toLowerCase();
  return v === 'ptv' || v === 'services_test_hiv';
}

//let id_counter = 0;

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export default {
  name: "App",
  components: {
    SearchField,
    MainMap,
    RadioButton,
    SearchResults,
//    AboutPage,
    ModalWindow,
    PlaceDetailsModal,
    SiteBreadcrumbs,
    HeaderBar,
  },

  created() {
    this.loadData();
  },

  data: function () {
    return {
      data: null,
      selected: null,
      header: !inIframe(),
//      section: "about",
      section: "zoz",
      term: "",
      showModal: false,
      selectedGroup: null,
      selectedServices: [],
      filteredResults: null,
      localFilteredPoints: [], // Локальне зберігання оброблених точок
      showPlaceDetailsModal: false, // Контроль відкриття/закриття модального вікна
      selectedPointDetails: null, // Дані для вибраної точки
    };
  },

  computed: {
    points() {
      // Перевіряємо, чи є дані
      if (!this.data) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("No data available in points().");
        }
        return [];
      }

      // Вибираємо точки залежно від активної секції
      if (this.section === 'harm_reduction') {
        const points = [
          ...(this.data.provision_service_point || []),
          ...(this.data.testing_points || []),
        ];
        return points;
      } else if (this.section === 'zoz') {
        const points = this.data.health_institution || [];
        return points;
      }

      const points = [];
      return points;
    },

    filtered_points() {
      if (!this.points || !Array.isArray(this.points)) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("⚠ No points available or points is not an array in filtered_points().");
        }
        return [];
      }

      if (this.section === "zoz") {
        let result = this.processZozPoints();
        if (this.term && this.term.trim() !== "") {
          const loweredTerm = this.term.trim().toLowerCase();
          result = result.filter(p => (p.search_field || "").toLowerCase().includes(loweredTerm));
        }
        return result;
      }

      if (this.section === "harm_reduction") {
        const selectedGroupCode = typeof this.selectedGroup === 'string'
          ? this.selectedGroup
          : this.selectedGroup?.group || null;
        const selectedGroupLabel = selectedGroupCode
          ? vulnerabilityGroupLabels[selectedGroupCode]
          : null;
        const selectedNormalizedServices = this.selectedServices.map(s => serviceMapping[s] || s);

        const filtered = this.points.filter(point => {
          const isSyrex = point.type === 'SYREX';
          const isOcf = point.type === 'OCF';

          const selectedGroupCode = typeof this.selectedGroup === 'string'
            ? this.selectedGroup
            : this.selectedGroup?.group;
          const selectedGroupUkr = vulnerabilityGroupLabels[selectedGroupCode];

          const groupMatch =
            !selectedGroupCode ||
            (
              Array.isArray(point.vulnerability_groups) &&
              [...point.vulnerability_groups].includes(selectedGroupUkr)
            );

          const servicesMatch =
            selectedNormalizedServices.length === 0 ||
            selectedNormalizedServices.every(s => point[s] === true);

          const isGeneral =
            isOcf &&
            selectedNormalizedServices.includes("services_test_HIV") &&
            point.is_general_hiv_point;

          if (isSyrex) {
            return groupMatch && servicesMatch;
          } else if (isOcf) {
            // Додаємо підтримку для консультацій
            const hasConsultation = selectedNormalizedServices.includes("consultation") && point.consultation;
            return isGeneral || hasConsultation;
          }

          return false;
        });

        const grouped = {};
        filtered.forEach(point => {
          const key = point.organisation?.title || point.title;
          if (!grouped[key]) {
            grouped[key] = { title: key, data: [] };
          }
          grouped[key].data.push(point);
        });

        return Object.values(grouped);
      }

      return this.points;
    },
    // Add localPoints as a computed property (for MainMap.vue refactor)
    localPoints() {
      return this.points ? [...this.points] : [];
    },
    isHivSelected() {
      return Array.isArray(this.selectedServices) && this.selectedServices.some(isHivServiceKey);
    }
  },

  methods: {
    onChangeGroupServices() {
      this.showModal = true;
    },
    logBreadcrumbs() {
    },
    processZozPoints() {
      const processedPoints = this.points.flatMap(point => {
          let lat = point.latitude ? +point.latitude : null;
          let lng = point.longitude ? +point.longitude : null;

          if (lat !== null && lng !== null) {
              return {
                  ...point,
                  title: point.title,
                  latitude: lat,
                  longitude: lng
              };
          } else {
              if (process.env.NODE_ENV !== 'production') {
                console.warn(`⚠ Skipping ЗОЗ point without coordinates: ${point.title}`);
              }
              return [];
          }
      });
      return processedPoints;
  },

    processHarmReductionPoints() {
      const processedPoints = this.filteredResults?.flatMap(point => {
        if (!Array.isArray(point.data)) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn("ПЗШ point is missing 'data' or it's not an array:", point);
          }
          return [];
        }

        return point.data.map(addr => ({
          ...addr,
          title: point.title, // Додаємо заголовок для кожної адреси
        }));
      }) || [];
      return processedPoints;
    },

    updateFilteredPoints() {
      if (!Array.isArray(this.filtered_points) || this.filtered_points.length === 0) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("⚠ filtered_points is empty or invalid!");
        }
        return;
      }

      // ❗ Фільтруємо лише ті точки, які мають координати
      this.localFilteredPoints = this.filtered_points.filter(p => p.latitude !== null && p.longitude !== null);

      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.main_map) {
            this.$refs.main_map.points = [...this.localFilteredPoints];
          } else {
            if (process.env.NODE_ENV !== 'production') {
              console.warn("⚠ main_map ref is still undefined.");
            }
          }
        }, 300);
      });
    },

    async loadData() {
      try {
        const [data] = await Promise.all([d3.json(API_ROOT, { credentials: 'same-origin' })]);

//      id_counter = 0;

        // 🔹 Об'єднуємо `provision_service_point` та `testing_points`
        let provision_service_points = [...(data.provision_service_point || []), ...(data.testing_points || [])];

        // Обробляємо кожну адресу як окрему точку
        let finalProvisionPoints = prepare_map_data(provision_service_points, "soc");

        // 🔹 Обробляємо заклади охорони здоров'я (ЗОЗ)
        let finalHealthInstitutions = prepare_map_data(data.health_institution || [], "zoz", false);

        // Зберігаємо дані в `this.data`
        this.data = {
          provision_service_point: finalProvisionPoints,
          health_institution: finalHealthInstitutions
        };
      } catch (err) {
        console.error('Failed to fetch API data:', err);
        // Keep the app usable even without API – set empty safe defaults
        this.data = {
          provision_service_point: [],
          health_institution: []
        };
      }
    },

    handleTabChange(tab) {
      this.section = tab; // Змінюємо активну вкладку
      if (tab === 'harm_reduction') {
        // Відкривати модалку тільки якщо група або послуги ще НЕ обрані
        if (!this.selectedGroup || this.selectedServices.length === 0) {
          this.showModal = true;
        }
      }
      if (tab === 'about' || tab === 'zoz') {
        this.selectedGroup = null;
        this.selectedServices = [];
      }
    },

    handleModalConfirm(data) {
      this.selectedGroup = data.group;
      const services = Array.isArray(data.services) ? data.services : [];
      // If HIV testing (ptv) is chosen, force single selection
      this.selectedServices = services.some(isHivServiceKey) ? ['ptv'] : services;
      this.showModal = false; // Закриваємо модальне вікно
      this.filterMapData();
    },

    handleGroupSelected(newGroup) {
      this.selectedGroup = newGroup;
    },

    filterMapData() {
      if (!this.points || !Array.isArray(this.points)) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("⚠ Points data is not available or is not an array.");
        }
        return;
      }

      // 🔐 Guard: if HIV testing is chosen, force single selection
      if (Array.isArray(this.selectedServices) && this.selectedServices.some(isHivServiceKey)) {
        if (!(this.selectedServices.length === 1 && isHivServiceKey(this.selectedServices[0]))) {
          this.selectedServices = ['ptv'];
        }
      }

      const backendServices = this.selectedServices.map(service => serviceMapping[service] || service);

      this.filteredResults = this.points.map(point => {
        if (!point.data || !Array.isArray(point.data)) {
          // ✅ Додаємо підтримку для is_general_hiv_point, якщо послуга = тестування на ВІЛ
          const normalizedHIVService = serviceMapping["ptv"];
          if (
            backendServices.includes(normalizedHIVService) &&
            point.is_general_hiv_point &&
            point.latitude &&
            point.longitude
          ) {
            return {
              title: point.organisation?.title || point.title,
              latitude: +point.latitude,
              longitude: +point.longitude,
              uid: `${point.uid}-${point.latitude}-${point.longitude}`.hashCode(),
              address: point.address || '',
              search_field: point.search_field || '',
              data: [
                {
                  latitude: +point.latitude,
                  longitude: +point.longitude,
                  services: [normalizedHIVService],
                  vulnerability_groups: [],
                }
              ],
              full_data: point
            };
          }

          return false;
        }

        return point.data.some(addr => {
          const matchesGroup = !this.selectedGroup ||
            (
              addr.vulnerability_groups && addr.vulnerability_groups.includes(this.selectedGroup)
            );
          if (!Array.isArray(addr.services)) {
            if (process.env.NODE_ENV !== 'production') {
              console.warn("❌ addr.services is not an array:", addr);
            }
          }
          const matchesServices = this.selectedServices
            .map(service => serviceMapping[service])
            .every(service => {
              const hasService = addr.services?.includes(service);
              return hasService;
            });
          return matchesGroup && matchesServices;
        });
      });

      if (!Array.isArray(this.filteredResults)) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("⚠ filteredResults is not an array! Defaulting to [].");
        }
        this.filteredResults = [];
      }
    },

    select_point(p, scrollIntoView) {
      if (this.selected) this.selected.selected = false;
      this.selected = p;

      if (this.selected) {
        this.selected.selected = true;

        // Встановлюємо дані для модального вікна
        this.selectedPointDetails = this.selected;
        this.showPlaceDetailsModal = true;

        if (scrollIntoView) {
          setTimeout(() => this.$refs.search_results.scrollIntoView(p), 0);
        } else {
          this.$refs.search_results.scrollIntoView(null);
        }
      }
    },

    closePlaceDetailsModal() {
      this.showPlaceDetailsModal = false;
    },
  },
  watch: {
    selectedGroup() {
      this.logBreadcrumbs();
    },
    selectedServices: {
      deep: true,
      handler(val) {
        // If 'ptv' is present, enforce single-selection of only 'ptv'
        if (Array.isArray(val) && val.some(isHivServiceKey)) {
          if (!(val.length === 1 && val[0] === 'ptv')) {
            this.selectedServices = ['ptv'];
          }
        }
        this.logBreadcrumbs();
      }
    },
    filtered_points: function (newVal) {
      if (!Array.isArray(newVal) || newVal.length === 0) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("⚠ filtered_points is empty or invalid!");
        }
      }
      this.updateFilteredPoints();
    },
    term() {
      this.updateFilteredPoints();
    }
  },
};

function prepare_map_data(points, section, selected = false) {
  let processedPoints = [];

  points.forEach(p => {
    if (section === "zoz") {
      // 🔹 Заклади ЗОЗ: беремо лише основні координати закладу
      let lat = p.latitude ? +p.latitude : null;
      let lng = p.longitude ? +p.longitude : null;

      if (lat !== null && lng !== null) {
        processedPoints.push({
          ...p,
          uid: `${p.uid}-${lat}-${lng}-${Math.random().toString(36).substr(2, 9)}`,
          title: p.name || p.title,
          selected: selected,
          latitude: lat,
          longitude: lng,
          address: address(p, section),
          search_field: search_field(p, section),
          full_data: { ...p, address: address(p, section) }, // 💡 Гарантовано додаємо адресу
        });
      }
    } else {
      // 🔹 Точки ПЗШ: кожна точка окремо (кілька адрес = кілька записів)
      let lat = p.latitude ? +p.latitude : null;
      let lng = p.longitude ? +p.longitude : null;

      if (lat !== null && lng !== null) {
        processedPoints.push({
          ...p,
          uid: `${p.uid}-${lat}-${lng}`.hashCode(),
          title: p.organisation?.title || p.title,
          selected: selected,
          latitude: lat,
          longitude: lng,
          address: address(p, section),
          search_field: search_field(p, section),
          full_data: { ...p, address: address(p, section) }, // 💡 Додаємо адресу
        });
      }

      // Якщо є додаткові адреси в `data`, додаємо їх окремо
      if (Array.isArray(p.data) && p.data.length > 0) {
        p.data.forEach(addr => {
          let addrLat = addr.latitude ? +addr.latitude : null;
          let addrLng = addr.longitude ? +addr.longitude : null;

          if (addrLat !== null && addrLng !== null) {
            processedPoints.push({
              ...addr,
              uid: `${p.uid}-${addrLat}-${addrLng}`.hashCode(),
              title: p.organisation?.title || p.title, // Використовуємо назву організації
              selected: selected,
              latitude: addrLat,
              longitude: addrLng,
              address: address(addr, section),
              search_field: search_field(addr, section),
              full_data: { ...addr, address: address(addr, section) }, // 💡 Додаємо адресу
            });
          } else {
            if (process.env.NODE_ENV !== 'production') {
              console.warn(`❌ Skipping address with missing coordinates:`, addr);
            }
          }
        });
      }
    }
  });

  return processedPoints;
}

String.prototype.hashCode = function () {
  var hash = 0,
      i, chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr = this.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
  }
  return hash;
};
</script>

<style lang="scss">
@import "@/assets/_mixins.scss";

:root {
  --col-mainblue: #2b4181;
  --col-lightblue: #367ae8;
  --col-icon-blue: #2053b5;
  --col-icon-orange: #ffa800;
  --col-tab-orange: #e59412;
  --col-text-orange: #de6228;
  --col-text-green: #009045;
  --col-grey: #f7f7f7;
  --col-main-grey: #aaa;
  --col-mainblue0: #0174f0;
  --col-grey-bb: #717e85;
  --col-green: #33b6b1;
}

@font-face {
  font-family: 'Fixel Display';
  src: url('@/assets/fonts/FixelDisplay-Regular.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Fixel Display';
  src: url('@/assets/fonts/FixelDisplay-Medium.otf') format('opentype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Fixel Display';
  src: url('@/assets/fonts/FixelDisplay-SemiBold.otf') format('opentype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Fixel Display';
  src: url('@/assets/fonts/FixelDisplay-Bold.otf') format('opentype');
  font-weight: bold;
  font-style: normal;
}

body {
  font-family: 'Fixel Display', "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  margin: 0;
  padding: 0;
  background: white;
}

input {
  font-family: 'Fixel Display', "Open Sans", Helvetica, Arial, sans-serif;
}

body,
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

header {
  display: flex;
  justify-content: space-between;
  padding: 0.5em 1rem;
//  background: var(--col-mainblue);
  color: white;
}

.container {
  max-width: 1600px;
  margin: 0 auto;
}

.main-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-row-gap: 1em;
  grid-column-gap: 0;
  margin: 0 1rem 0.5rem;
  padding: 1rem 0.5rem 0.5rem;
}

.main-grid.single-column {
  grid-template-columns: 1fr;
}

.right-column {
  color: var(--col-mainblue);
  padding: 2rem;
  border-radius: 8px;
}

@include for-mobile {
  .container {
    padding: 0 10px;
  }

  .main-grid {
    display: flex;
    flex-direction: column;
  }

  .main-map {
    // max-height: 62vw;
  }
}


.subheader {
  margin-bottom: 4em;
  max-width: 60em;

  color: var(--col-green);

  p {
    margin-bottom: 0.8rem;
  }

}

.small-text {
  color: var(--col-main-grey);
}

.light-text {
  color: white;
  margin: 0.5rem 0 0;
}

.contacts {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.contacts a {
  display: block;
  margin: 5px 0;
  color: var(--col-text-green);
}

.radio-buttons {
  background: var();
  display: flex;
  padding: 0 1rem;
  position: relative;
  height: 50px;

  .radio-buttons::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: var(--col-mainblue);
  }

  .line {
    cursor: pointer;
    color: var(--col-mainblue);
    display: flex;
    align-items: center;
    padding: 0.75em 0.5rem;
    font-size: 1.25em;
    color: var(--col-mainblue);
    transition: background 0.3s, border-radius 0.3s;
    border-bottom: none;
    border-radius: 20px 20px 0 0;
    position: relative;

    svg {
      margin-right: 0.5em;

      circle {
        stroke: var(--col-mainblue);
      }
    }
  }

  .line[checked] {
    background: white;
    color: var(--col-mainblue);
    font-weight: 600;
    border: 2px solid var(--col-mainblue);
    border-bottom: none;
    position: relative;
    z-index: 1;

    svg {
      circle {
        stroke: var(--col-mainblue);
        fill: var(--col-tab-orange);
      }
    }
  }

  .line::after {
    content: "";
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 2px;
    background: var(--col-mainblue);
  }

  .line[checked]::after {
    display: none;
  }

  :hover svg {
    fill: var(--col-tab-orange);
  }
}

.change-selection-button {
  background-color: var(--col-mainblue);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: var(--col-lightblue);
  }
}

</style>
